<template>
  <div class="co-container-sm mb-[3.25rem]">
    <!-- SP表示 -->
    <div class="text-center lg:hidden">
      <!-- 12週間 -->
      <div class="bg-co-white flex min-h-[8.1875rem] flex-col justify-center gap-2 bg-co-warning-500 p-4 text-white">
        <!-- バッジ -->
        <img
          class="mx-auto"
          src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
          alt="先割"
          width="61"
          height="34"
          loading="lazy"
        >
        <h3 class="co-display-10 mb-0 font-bold">
          12週間プラン
        </h3>
        <span class="co-display-13 font-normal">多忙で時間がない方向け</span>
      </div>
      <div>
        <!-- 料金 -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <b class="mb-1 block font-normal text-co-gray-600">
            {{ $addComma(social12WeeksPlan.tax_included_price) }}円<span class="te-tax-text">（税込）</span>
          </b>
          <p class="mb-4 text-co-gray-600 md:mb-5">
            <span class="block md:inline">
              分割払い例<span class="ml-1 font-bold">{{ $addComma(social12WeeksPlan.price_for_max_installment) }}</span>円/月<span class="co-display-14 ml-1">※1</span>
            </span>
          </p>
          リスキリング<br class="md:hidden">補助金適応
          <div class="flex flex-col items-center justify-center">
            <div
              class="inline-block bg-[#1ba7f5] px-2 py-0.5 leading-6 text-[#ffff33]"
            >
              <span
                class="text-[0.625rem] font-bold"
              >最大</span>
              <span
                class="text-[0.875rem] font-bold"
              >70</span>
              <span
                class="text-[0.625rem] font-bold"
              >％還元で</span>
            </div>
            <div class="te-balloon-triangle-down" />
          </div>
          <b class="block font-normal text-co-gray-600">
            <span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(prices.social_12weeks.reskilling_price) }}</span>円
          </b>
        </div>
        <!-- 実質負担額 -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <span class="mb-2 block font-bold">
            副業保証5万円ご対応いただいた場合
          </span>
          <span class="mb-0 block font-bold">
            実質負担額
          </span>
          <b class="block font-normal text-co-gray-600">
            <span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(prices.social_12weeks.reskilling_price - 50000) }}</span>円
          </b>
        </div>
        <!-- 受講期間 -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <span class="mb-1 block font-bold lg:hidden">受講期間</span>
          <b class="font-normal">
            <span class="mb-2 block">
              <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
            </span>
            <span class="block">
              <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt12) }}月{{ dateToDay(membershipEndsAt12) }}日 ({{ dateToWeek(membershipEndsAt12) }})
            </span>
          </b>
        </div>
        <!-- メンタリング -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <span class="mb-1 block font-bold lg:hidden">メンタリング</span>
          23回
        </div>
        <!-- チャットサポート -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <span class="mb-1 block font-bold lg:hidden">チャットサポート</span>
          24時間以内に回答
        </div>
        <!-- 学習時間の目安 -->
        <div class="te-price-striped border border-[#dee2e6] p-3">
          <span class="mb-1 block font-bold lg:hidden">学習時間の目安</span>
          17時間（1週間）
        </div>
        <!-- 実案件サポート -->
        <div
          v-if="matterSupport"
          class="te-price-striped border border-[#dee2e6] p-3"
        >
          <span class="mb-1 block font-bold lg:hidden">
            実案件サポート
            <span class="co-display-14 ml-1">※2</span>
          </span>
          あり
        </div>
      </div>
      <p class="co-display-14 mt-2 text-left text-co-gray-500">
        ※1 料金表の分割払い例は24回払いの場合。ご契約のカード会社によって異なります。
      </p>
    </div>

    <!-- PC表示 -->
    <div class="co-container-sm hidden lg:block">
      <table class="table mb-4 text-center">
        <thead>
          <tr class="h-[6.25rem]">
            <th class="w-[22%] px-3" />
            <!-- 12週間プラン -->
            <th class="relative bg-co-warning-500 px-3 py-0 text-white">
              <img
                class="absolute left-1/2 top-[-3%] inline-block -translate-x-1/2 -translate-y-1/2"
                src="~/assets/images/Te/TeCourse/PriceTable/price-badge-sakiwari.svg"
                alt="先割"
                width="61"
                height="34"
                loading="lazy"
              >
              <h3 class="co-display-10 mb-0 font-bold">
                12週間プラン
              </h3>
              <span class="co-display-13 font-normal">多忙で時間がない方向け</span>
            </th>
          </tr>
        </thead>
        <tbody>
          <!-- 料金 -->
          <tr class="h-[6.25rem]">
            <th class="whitespace-nowrap border border-[#dee2e6] px-3">
              料金
              <br class="hidden lg:block">
              （税込）
            </th>
            <!-- 12週間 -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-1 block font-normal">
                {{ $addComma(social12WeeksPlan.tax_included_price) }}円<span class="te-tax-text">（税込）</span>
              </b>
              <p class="mb-4 text-co-gray-600 md:mb-5">
                <span class="block md:inline">分割払い例</span>
                <span class="ml-1 font-bold">{{ $addComma(social12WeeksPlan.price_for_max_installment) }}</span>円/月<span class="co-display-14 ml-1">※1</span>
              </p>
              <h3 class="co-display-12 mb-1 font-bold md:mb-2">
                <span class="block md:inline">リスキリング</span>
                <span>補助金適応</span>
              </h3>
              <div class="flex flex-col items-center justify-center">
                <div
                  class="inline-block bg-[#1ba7f5] px-2 py-0.5 leading-normal text-[#ffff33]"
                >
                  <span
                    class="text-[0.625rem] font-bold"
                  >最大</span>
                  <span
                    class="text-[0.875rem] font-bold"
                  >70</span>
                  <span
                    class="text-[0.625rem] font-bold"
                  >％還元で</span>
                </div>
                <div class="te-balloon-triangle-down" />
              </div>
              <b class="block font-normal text-co-gray-600">
                <span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(prices.social_12weeks.reskilling_price) }}</span>円
              </b>
            </td>
          </tr>
          <!-- 実質負担額 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              副業保証5万円
              <br>
              ご対応いただいた場合
            </th>
            <!-- 12週間プラン -->
            <td class="border border-[#dee2e6] px-3">
              <span class="block font-bold">実質負担額</span>
              <b class="block font-normal text-co-gray-600">
                <span class="co-display-7 px-1 font-bold text-co-warning-500">{{ $addComma(prices.social_12weeks.reskilling_price - 50000) }}</span>円
              </b>
            </td>
          </tr>
          <!-- 受講期間 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              受講期間
            </th>
            <!-- 12週間プラン -->
            <td class="border border-[#dee2e6] px-3">
              <b class="mb-2 block font-normal">
                <span class="mr-2 font-bold">開始</span>{{ beginsMonth }}月{{ beginsDays }}日 ({{ beginsDayOfWeek }})
              </b>
              <b class="block font-normal">
                <span class="mr-2 font-bold">終了</span>{{ dateToMonth(membershipEndsAt12) }}月{{ dateToDay(membershipEndsAt12) }}日 ({{ dateToWeek(membershipEndsAt12) }})
              </b>
            </td>
          </tr>
          <!-- メンタリング -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              メンタリング
            </th>
            <!-- 12週間プラン -->
            <td class="border border-[#dee2e6] px-3">
              23回
            </td>
          </tr>
          <!-- チャットサポート -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              チャットサポート
            </th>
            <!-- 12週間プラン -->
            <td class="border border-[#dee2e6] px-3">
              24時間以内に回答
            </td>
          </tr>
          <!-- 学習時間の目安 -->
          <tr class="h-[6.25rem]">
            <th class="border border-[#dee2e6] px-3">
              学習時間の目安
              <br class="hidden lg:block">
              （1週間）
            </th>
            <!-- 12週間プラン -->
            <td class="border border-[#dee2e6] px-3">
              17時間
            </td>
          </tr>
        </tbody>
      </table>
      <p class="co-display-14 mt-2 text-left text-co-gray-500">
        ※1 料金表の分割払い例は24回払いの場合。ご契約のカード会社によって異なります。
      </p>
    </div>

    <!-- 別途料金について -->
    <div
      v-if="$slots.additionalFees"
      class="mt-5 flex flex-col items-center gap-1 lg:flex-row lg:items-start lg:gap-4"
    >
      <div class="co-display-11 flex items-center gap-1 whitespace-nowrap font-bold text-co-danger-500">
        <FontAwesomeIcon
          :icon="faCircleInfo"
          class="fa-fw size-5"
        />別途料金について
      </div>
      <div>
        <slot name="additionalFees">
          別途料金についてのテキスト
        </slot>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faCircleInfo } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

interface Methods {
  dateToMonth(date: Date | null): number | '-'
  dateToDay(date: Date | null): number | '-'
  dateToWeek(date: Date | null): string
}
interface Computed {
  plans: any
  beginsAt: Date | null
  beginsMonth: number | '-'
  beginsDays: number | '-'
  beginsDayOfWeek: '日' | '月' | '火' | '水' | '木' | '金' | '土' | '-'
  membershipEndsAt12: Date | null
  social12WeeksPlan: object
}
interface Props {
  course: any
  latestCohort: any
  currentPromotion: any
  matterSupport: boolean
}
const options = {
  setup() {
    return { faCircleInfo }
  },
  props: {
    course: {
      type: Object,
    },
    latestCohort: {
      type: Object,
    },
    currentPromotion: {
      default: null,
    },
    matterSupport: {
      type: Boolean,
      default: false,
    },
  },
  filters: {
    addComma(value: number) {
      return value ? value.toLocaleString() : '-'
    },
  },
  computed: {
    plans() {
      return this.course ? this.course.attributes.plans : null
    },
    beginsAt() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.begins_at)
        : null
    },
    beginsMonth() {
      return this.beginsAt ? this.beginsAt.getMonth() + 1 : '-'
    },
    beginsDays() {
      return this.beginsAt ? this.beginsAt.getDate() : '-'
    },
    beginsDayOfWeek() {
      if (this.beginsAt) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          this.beginsAt.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
    membershipEndsAt12() {
      return this.latestCohort
        ? new Date(this.latestCohort.attributes.membership_ends_at12)
        : null
    },
    social12WeeksPlan() {
      return this.plans
        ? this.plans.social_12weeks
        : { tax_included_price: '-' }
    },
    prices() {
      return this.course
        ? this.course.attributes.prices
        : {
            social_12weeks: { reskilling_price: '-' },
          }
    },
  },
  methods: {
    dateToMonth(date: Date | null) {
      return date ? date.getMonth() + 1 : '-'
    },
    dateToDay(date: Date | null) {
      return date ? date.getDate() : '-'
    },
    dateToWeek(date: Date | null) {
      if (date) {
        const dayOfWeek = ['日', '月', '火', '水', '木', '金', '土'][
          date.getDay()
        ]
        return dayOfWeek as '日' | '月' | '火' | '水' | '木' | '金' | '土'
      } else {
        return '-'
      }
    },
  },
  components: {
    FontAwesomeIcon,
  }
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* 背景色 */
.te-price-striped:nth-of-type(odd),
.table tbody tr:nth-of-type(odd) {
  @apply bg-[#f9f9f9];
}

.te-price-striped:nth-of-type(even),
.table tbody tr:nth-of-type(even) {
  @apply bg-white;
}

.te-balloon-triangle-down {
  width: 0;
  height: 0;
  border-color: #1ba9f5 transparent transparent;
  border-style: solid;
  border-width: 6px 6px 0;
}

.te-tax-text {
  font-size: 0.625rem;
  @media (min-width: 768px) {
    font-size: 0.75rem;
  }
}
</style>
